import React from 'react'
import NoPermissions from '../../../../pages/no-permissions'
import LoaderPermissions from '../../../../pages/no-permissions/LoaderPermissions'
import WelcomePage from '../../../../pages/no-permissions/WelcomePage'

function CheckPermissions({ loadingMainPermission, array, children, statistics }) {
    return (
        <>
            {
                array && !loadingMainPermission && (
                    <>
                        {children}
                    </>
                )
            }
            {
                !array && !loadingMainPermission && !statistics &&
                <NoPermissions isHeight />
            }
            {
                !array && !loadingMainPermission && statistics &&
                    <WelcomePage />
            }
            {
                loadingMainPermission && (
                    <LoaderPermissions isHeight />
                )
            }
        </>
    )
}

export default CheckPermissions